'use client';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

/**
 * Reports client-side navigations to the request log. Middleware can't tell them apart from
 * prefetches, and the first page load is already logged as a document request.
 */
const NavigationBeacon = () => {
  const pathname = usePathname();
  const previous = useRef<string | null>(null);

  useEffect(() => {
    if (previous.current !== null && previous.current !== pathname) {
      const payload = JSON.stringify({ path: pathname, from: previous.current });
      try {
        if (!navigator.sendBeacon?.('/apis/log/navigation', payload)) {
          fetch('/apis/log/navigation', { method: 'POST', body: payload, keepalive: true }).catch(() => {});
        }
      } catch {
        // logging must never break navigation
      }
    }
    previous.current = pathname;
  }, [pathname]);

  return null;
};

export default NavigationBeacon;
